import { render, staticRenderFns } from "./CmsLink.vue?vue&type=template&id=d453bf24&"
import script from "./CmsLink.vue?vue&type=script&lang=js&"
export * from "./CmsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports